import { defineComponent as _defineComponent } from 'vue'
import AreaSessionFormItem from '@/components/form/AreaSessionFormItem.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import IconMessageBlock from '@/components/info/IconMessageBlock.vue';
import { Icon } from '@/lib/enum/Icon';
import {
  areaSessionsAcceptableDuration,
  areaSessionsNoOverlap,
} from '@/lib/forms/customValidators/shiftSessionsValidators';
import { getErrorMessages } from '@/plugins/vuelidate';
import { ShiftAreaSessionFormItemType } from '@/types/shiftSessionsForm';
import useVuelidate from '@vuelidate/core';
import { computed, reactive, watch } from 'vue';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'AreaSessionsForm',
  props: {
    date: null,
    shiftStartTime: null,
    shiftEndTime: null,
    shiftLocationId: null,
    areaSessions: null,
    updateAreaSessions: null
  },
  setup(__props: any) {

const props = __props as {
  date: Date;
  shiftStartTime: string;
  shiftEndTime: string;
  shiftLocationId: number;
  areaSessions: ShiftAreaSessionFormItemType[];
  updateAreaSessions: (sessions: ShiftAreaSessionFormItemType[]) => void;
}



/* DATA */
const form = reactive({
  areaSessions: props.areaSessions,
});

const validators = {
  areaSessions: {
    areaSessionsNoOverlap,
    areaSessionsAcceptableDuration: areaSessionsAcceptableDuration(
      () => props.shiftStartTime,
      () => props.shiftEndTime,
    ),
  },
};

const v$ = useVuelidate(validators, form, { $autoDirty: true });

/* COMPUTED */
// display error message only if inner forms have no validation errors
const displayErrorMessage = computed<boolean>(
  () => !v$.value.$errors.some((error) => error.$property !== 'areaSessions'),
);

/* METHODS */
const removeArea = (id: number) => {
  form.areaSessions = form.areaSessions.filter((a) => a.id !== id);
};

/* WATCH */
watch(form, (value) => {
  // in case we manage sessions in children components only
  if (!v$.value.areaSessions.$dirty) {
    v$.value.areaSessions.$touch();
  }
  props.updateAreaSessions(value.areaSessions);
});

return { __sfc: true,props, form, validators, v$, displayErrorMessage, removeArea, AreaSessionFormItem, InputGroup, IconMessageBlock, Icon, getErrorMessages }
}

})